import type { HeroContent, HeroPhaseContent } from './types';
import { EXTERNAL_LINKS } from './externalLinks';

/**
 * Base hero content (shared across all phases)
 */
export const heroContent: HeroContent = {
  title: {
    eyebrow: 'Meet Color Scales I/O:',
    text: 'Accessible color scales in seconds, not hours. All in ',
    highlightedText: 'Figma.',
    highlightClass: 'doodle--figma',
  },
  subtitle: [
    'Adobe Leonardo, meet your canvas. Build WCAG 2.1 and APCA-compliant color scales ',
    {
      text: 'inside Figma',
      href: EXTERNAL_LINKS.figmaPlugin,
      external: true,
    },
    ', tune them next to real components, and ship as Figma variables, design tokens, or code snippets. Fewer tool hops. More color that holds up.',
  ],
  primaryCTA: {
    text: 'Try for free',
    action: '#final-cta',
  },
};

/**
 * Phase-specific CTA overrides
 * The Hero component uses these based on VITE_LAUNCH_MODE
 */
export const heroPhaseContent: HeroPhaseContent = {
  preLaunch: {
    cta: {
      text: 'Get early access',
      action: '#final-cta',
    },
  },
  beta: {
    cta: {
      text: 'Try for free',
      action: '#final-cta',
    },
  },
  earlyBird: {
    cta: {
      text: 'Try for free',
      action: '#final-cta',
    },
  },
  stable: {
    cta: {
      text: 'Try for free',
      action: '#final-cta',
    },
  },
};
